import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function RisorsePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-violet-50 to-purple-50">
        <div className="max-w-5xl mx-auto px-6">
          <div className="inline-flex items-center gap-2 bg-violet-100 px-4 py-2 rounded-full mb-6">
            <i className="ri-folder-open-line text-violet-600"></i>
            <span className="text-violet-800 text-sm font-semibold whitespace-nowrap">Materiali Didattici</span>
          </div>
          <h1 className="font-serif text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Risorse Multimediali
          </h1>
          <p className="text-xl text-gray-700 leading-relaxed">
            Video, audio, schede stampabili, quiz e attività per approfondire lo studio dell'Iliade in classe e a casa.
          </p>
        </div>
      </section>

      {/* Resources Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {/* Video */}
            <div className="group cursor-pointer">
              <div className="overflow-hidden rounded-2xl mb-4 h-64 relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/0a2926edb43d113bd419479ab4993a3d.jpg" 
                  alt="Video Documentari" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-circle-line text-white text-6xl"></i>
                </div>
              </div>
              <span className="inline-block bg-lime-400 text-gray-900 px-4 py-1 rounded-full text-sm font-semibold mb-3 whitespace-nowrap">Video HD</span>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Documentari e Lezioni Animate</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                Video didattici che spiegano i temi principali, i personaggi e il contesto storico dell'Iliade con animazioni e ricostruzioni.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  <span>Introduzione all'Iliade (15 min)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  <span>La Guerra di Troia (20 min)</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-green-600"></i>
                  <span>I Personaggi Principali (25 min)</span>
                </li>
              </ul>
            </div>

            {/* Audio */}
            <div className="bg-gray-900 rounded-2xl p-8 flex flex-col justify-between group cursor-pointer hover:bg-gray-800 transition-colors">
              <div>
                <div className="w-20 h-20 flex items-center justify-center mb-6">
                  <i className="ri-headphone-line text-7xl text-lime-400"></i>
                </div>
                <span className="inline-block bg-lime-400 text-gray-900 px-4 py-1 rounded-full text-sm font-semibold mb-3 whitespace-nowrap">Podcast</span>
                <h3 className="text-xl font-bold text-white mb-2">Episodi Audio sui Temi</h3>
                <p className="text-gray-300 text-sm leading-relaxed mb-4">
                  Podcast che approfondiscono i temi dell'Iliade: l'ira, l'onore, il destino, la guerra e la pace.
                </p>
              </div>
              <ul className="space-y-2 text-sm text-gray-300">
                <li className="flex items-center gap-2">
                  <i className="ri-volume-up-line text-lime-400"></i>
                  <span>L'Ira di Achille</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-volume-up-line text-lime-400"></i>
                  <span>Eroi e Valori</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-volume-up-line text-lime-400"></i>
                  <span>Gli Dei nell'Iliade</span>
                </li>
              </ul>
            </div>

            {/* PDF */}
            <div className="group cursor-pointer">
              <div className="overflow-hidden rounded-2xl mb-4 h-64 relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=educational%20study%20worksheet%20printable%20materials%20for%20classical%20literature%20organized%20layout%20clean%20design%20academic%20notes%20student%20handout&width=600&height=800&seq=resource-worksheet-main-001&orientation=portrait" 
                  alt="Schede PDF" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-download-cloud-line text-white text-6xl"></i>
                </div>
              </div>
              <span className="inline-block bg-lime-400 text-gray-900 px-4 py-1 rounded-full text-sm font-semibold mb-3 whitespace-nowrap">PDF Scaricabili</span>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Schede di Studio</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                Materiali stampabili con riassunti, mappe concettuali, schemi e approfondimenti per lo studio individuale.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center gap-2">
                  <i className="ri-file-text-line text-orange-600"></i>
                  <span>Riassunto per canti</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-file-text-line text-orange-600"></i>
                  <span>Schede personaggi</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-file-text-line text-orange-600"></i>
                  <span>Mappe concettuali</span>
                </li>
              </ul>
            </div>

            {/* Quiz */}
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 flex flex-col justify-between group cursor-pointer hover:shadow-xl transition-shadow">
              <div>
                <div className="w-20 h-20 flex items-center justify-center mb-6">
                  <i className="ri-question-answer-line text-7xl text-orange-600"></i>
                </div>
                <span className="inline-block bg-orange-500 text-white px-4 py-1 rounded-full text-sm font-semibold mb-3 whitespace-nowrap">Quiz Interattivi</span>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Verifica le Tue Conoscenze</h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4">
                  Quiz a risposta multipla per testare la comprensione dei contenuti e prepararsi alle interrogazioni.
                </p>
              </div>
              <div className="space-y-2 text-sm text-gray-700">
                <div className="flex items-center justify-between bg-white rounded-lg p-3">
                  <span>Quiz Base (20 domande)</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
                <div className="flex items-center justify-between bg-white rounded-lg p-3">
                  <span>Quiz Avanzato (30 domande)</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>

            {/* Gallery */}
            <div className="group cursor-pointer">
              <div className="overflow-hidden rounded-2xl mb-4 h-64 relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=ancient%20greek%20archaeological%20artifacts%20museum%20collection%20pottery%20weapons%20armor%20trojan%20war%20period%20historical%20objects%20classical%20antiquity&width=600&height=800&seq=resource-gallery-main-001&orientation=portrait" 
                  alt="Galleria Immagini" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-gallery-line text-white text-6xl"></i>
                </div>
              </div>
              <span className="inline-block bg-lime-400 text-gray-900 px-4 py-1 rounded-full text-sm font-semibold mb-3 whitespace-nowrap">Galleria</span>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Immagini e Reperti</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                Fotografie di reperti archeologici, vasi greci, sculture e ricostruzioni dei luoghi della guerra di Troia.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center gap-2">
                  <i className="ri-image-line text-indigo-600"></i>
                  <span>Vasi con scene dell'Iliade</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-image-line text-indigo-600"></i>
                  <span>Scavi archeologici di Troia</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-image-line text-indigo-600"></i>
                  <span>Armi e armature micenee</span>
                </li>
              </ul>
            </div>

            {/* Activities */}
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 flex flex-col justify-between group cursor-pointer hover:shadow-xl transition-shadow">
              <div>
                <div className="w-20 h-20 flex items-center justify-center mb-6">
                  <i className="ri-group-line text-7xl text-green-600"></i>
                </div>
                <span className="inline-block bg-green-500 text-white px-4 py-1 rounded-full text-sm font-semibold mb-3 whitespace-nowrap">Attività</span>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Proposte Didattiche</h3>
                <p className="text-gray-700 text-sm leading-relaxed mb-4">
                  Idee per attività di gruppo, dibattiti, drammatizzazioni e progetti creativi sull'Iliade.
                </p>
              </div>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-center gap-2">
                  <i className="ri-lightbulb-line text-green-600"></i>
                  <span>Dibattito: Achille vs Ettore</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-lightbulb-line text-green-600"></i>
                  <span>Drammatizzazione scene chiave</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-lightbulb-line text-green-600"></i>
                  <span>Progetto: Giornale di guerra</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Interactive Map Section */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-white mb-6">Mappa Interattiva dei Luoghi</h2>
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                Esplora i luoghi chiave della guerra di Troia con la nostra mappa interattiva. Scopri dove si sono svolti gli eventi principali e visualizza la geografia del conflitto.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold mb-1">Troia</h3>
                    <p className="text-gray-400 text-sm">La città fortificata assediata dai Greci, situata nell'attuale Turchia.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold mb-1">Campo Acheo</h3>
                    <p className="text-gray-400 text-sm">L'accampamento greco sulla spiaggia, con le navi tirate a riva.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold mb-1">Monte Ida</h3>
                    <p className="text-gray-400 text-sm">La montagna sacra da cui Zeus osserva la battaglia.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold mb-1">Fiume Scamandro</h3>
                    <p className="text-gray-400 text-sm">Il fiume sacro che scorre vicino a Troia, teatro di battaglie.</p>
                  </div>
                </div>
              </div>
              <button className="bg-orange-500 text-white px-8 py-4 rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer">
                <i className="ri-map-2-line"></i>
                Esplora la Mappa
              </button>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d98304.89194847!2d26.1!3d39.95!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b0c8b0c8b0c8b0%3A0x0!2sTroy!5e0!3m2!1sen!2s!4v1234567890"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Mappa di Troia"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Study Activities */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center">Attività Didattiche Consigliate</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-discuss-line text-red-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Dibattito in Classe</h3>
                  <span className="inline-block bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">Attività di Gruppo</span>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4">
                Organizza un dibattito su temi controversi: Chi ha ragione tra Achille e Agamennone? Ettore è più eroico di Achille? La guerra è giustificata?
              </p>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2"><strong>Durata:</strong> 1-2 ore</p>
                <p className="text-sm text-gray-600"><strong>Obiettivo:</strong> Sviluppare pensiero critico e capacità argomentative</p>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-quill-pen-line text-orange-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Scrittura Creativa</h3>
                  <span className="inline-block bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">Attività Individuale</span>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4">
                Scrivi una lettera dal punto di vista di un personaggio: Achille che scrive a Patroclo, Andromaca a Ettore, o Elena che riflette sulle sue scelte.
              </p>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2"><strong>Durata:</strong> 1 ora</p>
                <p className="text-sm text-gray-600"><strong>Obiettivo:</strong> Immedesimarsi nei personaggi e comprendere le loro motivazioni</p>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-movie-line text-green-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Drammatizzazione</h3>
                  <span className="inline-block bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">Attività di Gruppo</span>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4">
                Metti in scena una delle scene chiave: l'addio di Ettore e Andromaca, il duello finale, o l'incontro tra Priamo e Achille.
              </p>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2"><strong>Durata:</strong> 2-3 ore (preparazione + esecuzione)</p>
                <p className="text-sm text-gray-600"><strong>Obiettivo:</strong> Comprendere le emozioni e le dinamiche dei personaggi</p>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-md">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-indigo-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-newspaper-line text-indigo-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Giornale di Guerra</h3>
                  <span className="inline-block bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap">Progetto di Classe</span>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4">
                Crea un giornale che racconta gli eventi dell'Iliade come se fossero notizie attuali: articoli, interviste, cronache di battaglia, necrologi.
              </p>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-600 mb-2"><strong>Durata:</strong> 1 settimana</p>
                <p className="text-sm text-gray-600"><strong>Obiettivo:</strong> Rielaborare creativamente i contenuti e lavorare in team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* For Teachers */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12 text-white">
            <div className="flex items-start gap-6 mb-8">
              <div className="w-16 h-16 bg-orange-500 rounded-2xl flex items-center justify-center flex-shrink-0">
                <i className="ri-user-star-line text-3xl"></i>
              </div>
              <div>
                <h2 className="text-3xl font-bold mb-3">Guida per Docenti</h2>
                <p className="text-gray-300 text-lg">Materiali e suggerimenti per insegnare l'Iliade in modo efficace e coinvolgente</p>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white/10 rounded-xl p-6">
                <h3 className="font-bold text-lg mb-3">📚 Programmazione Didattica</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Unità didattiche complete con obiettivi, tempi, metodologie e verifiche per un percorso di 15-20 ore.
                </p>
              </div>
              <div className="bg-white/10 rounded-xl p-6">
                <h3 className="font-bold text-lg mb-3">✏️ Verifiche e Griglie</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Test di verifica con soluzioni, griglie di valutazione e rubriche per interrogazioni orali e compiti scritti.
                </p>
              </div>
              <div className="bg-white/10 rounded-xl p-6">
                <h3 className="font-bold text-lg mb-3">🎯 Obiettivi di Apprendimento</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Competenze chiave da sviluppare: comprensione del testo, analisi letteraria, contestualizzazione storica.
                </p>
              </div>
              <div className="bg-white/10 rounded-xl p-6">
                <h3 className="font-bold text-lg mb-3">💡 Metodologie Innovative</h3>
                <p className="text-gray-300 text-sm leading-relaxed">
                  Suggerimenti per lezioni interattive, flipped classroom, cooperative learning e uso delle tecnologie.
                </p>
              </div>
            </div>
            
            <button className="bg-orange-500 text-white px-8 py-4 rounded-lg hover:bg-orange-600 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <i className="ri-download-line"></i>
              Scarica la Guida Completa (PDF)
            </button>
          </div>
        </div>
      </section>

      {/* Navigation */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col sm:flex-row gap-4 justify-between">
            <Link to="/timeline" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              <span className="whitespace-nowrap">Timeline degli Eventi</span>
            </Link>
            <Link to="/" className="flex items-center gap-2 text-orange-600 hover:text-orange-700 transition-colors font-semibold cursor-pointer">
              <span className="whitespace-nowrap">Torna alla Home</span>
              <i className="ri-home-line"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
